/**
 * @file src/api/purchasePayment.api.js
 * @description Vendor payments — settle bills. /purchases/payments
 */

import { apiClient } from "lib/axios";

const normalizePayment = (payment) => {
  if (!payment) return payment;
  return {
    ...payment,
    id: payment.id || payment._id,
    vendorId:
      payment.vendorId?._id || payment.vendorId?.id || payment.vendorId || "",
    vendorName: payment.vendorName || payment.vendorId?.name || "—",
  };
};

const normalizeListResponse = (data) => {
  const payments = data?.payments || data?.data?.payments || data?.data || [];
  return {
    ...data,
    payments: Array.isArray(payments) ? payments.map(normalizePayment) : [],
  };
};

const normalizeItemResponse = (data) => {
  const payment = data?.payment || data?.data?.payment || data?.data || data;
  return { ...data, payment: normalizePayment(payment) };
};

const buildCleanPayload = (payload) => ({
  vendorId: payload.vendorId,
  branchId: payload.branchId || null,
  paymentDate: payload.paymentDate,
  paymentMode: payload.paymentMode,
  amount: payload.amount,
  allocations: Array.isArray(payload.allocations) ? payload.allocations : [],
  depositTo: payload.depositTo || null,
  issuer: payload.issuer || null,
  reference: payload.reference || null,
  comments: payload.comments || null,
});

export const getPurchasePayments = async (params = {}) => {
  const { data } = await apiClient.get("/purchases/payments", { params });
  return normalizeListResponse(data);
};

export const getPurchasePaymentById = async (id) => {
  const { data } = await apiClient.get(`/purchases/payments/${id}`);
  return normalizeItemResponse(data);
};

export const createPurchasePayment = async (payload) => {
  const { data } = await apiClient.post(
    "/purchases/payments",
    buildCleanPayload(payload),
  );
  return normalizeItemResponse(data);
};

export const voidPurchasePayment = async (id, body = {}) => {
  const { data } = await apiClient.post(`/purchases/payments/${id}/void`, body);
  return normalizeItemResponse(data);
};
